
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

interface PollWidgetEmptyProps {
  message: string;
}

const PollWidgetEmpty: React.FC<PollWidgetEmptyProps> = ({ message }) => {
  return (
    <Card className="border-dashed border-muted">
      <CardContent className="flex flex-col items-center justify-center p-6 text-center">
        <AlertCircle className="h-12 w-12 text-muted-foreground mb-4" />
        <p className="text-muted-foreground">{message}</p>
      </CardContent>
    </Card>
  );
};

export default PollWidgetEmpty;
